import React from 'react';
import { Box, Container, Typography, IconButton, Tooltip } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import DataExportForm from '../components/DataExportForm';

interface DataExportPageProps {
  setSelectMenu: (menu: string) => void;
}

const DataExportPage: React.FC<DataExportPageProps> = ({ setSelectMenu }) => {
  const handleBackClick = () => {
    setSelectMenu('menu');
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Tooltip title="Voltar ao menu principal">
            <IconButton
              onClick={handleBackClick}
              sx={{ 
                alignSelf: 'flex-start',
                color: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.light',
                  color: 'white'
                }
              }}
            >
              <ArrowBack />
            </IconButton>
          </Tooltip>
        </Box>
        <Typography variant="h3" component="h1" gutterBottom>
          Exportação de Dados
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Exporte dados de tickets e itens de solicitação de crédito em formato CSV com filtros avançados.
        </Typography>
      </Box>

      <DataExportForm />
    </Container>
  );
};

export default DataExportPage;
